import { render, staticRenderFns } from "./base-progress-bar.vue?vue&type=template&id=b8d3e4c8&scoped=true&"
import script from "./base-progress-bar.vue?vue&type=script&lang=js&"
export * from "./base-progress-bar.vue?vue&type=script&lang=js&"
import style0 from "./base-progress-bar.vue?vue&type=style&index=0&id=b8d3e4c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d3e4c8",
  null
  
)

export default component.exports